import { FilterMappingType } from '@business/entities/filter';

export function getOperators(type: FilterMappingType) {
  switch (type) {
    case 'string':
      return ['is', 'is not', 'is empty', 'is not empty', 'contains', 'start with'];
    case 'array':
      return ['is', 'is not'];
    case 'date':
      return ['is', 'is not', 'is empty', 'is not empty', 'is before', 'is after'];
    default:
      return [];
  }
}
